import React, {Component} from 'react';
import { default as DatePickerPlugin } from 'react-datepicker';


class DatePicker extends Component {

    handleChange = (value) => {
        const { name, form, onChange } = this.props;

        if (onChange) onChange(value);
        if (form) form.setFieldValue(name, value);
    };

    render() {
        const { name, modifiers, form, ...rest } = this.props;
        const value = form.values[name];
        let className = 'datepicker';

        if (modifiers) modifiers.forEach(m => className+= ` datepicker--${m}`);

        return (
            <div className={className}>

                <div className={'datepicker__field'}>
                    <DatePickerPlugin
                        className="datepicker__input"
                        selected={(value && new Date(value)) || null}
                        onChange={this.handleChange}
                        {...rest}
                    />

                    <div className={'datepicker__icon'}>
                        <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0)" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M1.688 2.813h14.624c.621 0 1.125.503 1.125 1.124v12.376c0 .62-.504 1.125-1.125 1.125H1.688a1.125 1.125 0 01-1.125-1.125V3.938c0-.622.504-1.126 1.125-1.126zM.563 7.313h16.875M5.063 4.5V.562M12.938 4.5V.562"/>
                                <path d="M4.219 10.125a.281.281 0 100 .563.281.281 0 000-.563zM4.219 14.063a.281.281 0 100 .562.281.281 0 000-.563zM9 10.125a.281.281 0 100 .563.281.281 0 000-.563zM9 14.063a.281.281 0 100 .562.281.281 0 000-.563zM13.781 10.125a.281.281 0 100 .563.281.281 0 000-.563zM13.781 14.063a.281.281 0 100 .562.281.281 0 000-.563z"/>
                            </g>
                            <defs>
                                <clipPath id="clip0">
                                    <path d="M0 0h18v18H0V0z" fill="#fff"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
        );
    }
}

export { DatePicker };
